import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import api from "../api.js";
import "../style/css/WriteUs.css";

// Define the interface for our single form field
interface WriteUsForm {
  message: string;
}

const WriteUs: React.FC = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<WriteUsForm>();

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null); // New state for success message

  const onSubmit: SubmitHandler<WriteUsForm> = async (data) => {
    try {
      setSubmitting(true);
      setError(null);
      setSuccessMessage(null);

      await api.post("/write-us/", data);

      setSuccessMessage("Gracias por tus comentarios.");
      await new Promise((resolve) => setTimeout(resolve, 1500));
      navigate("/");
    } catch (err) {
      setError("Error al enviar el correo, por favor inténtalo de nuevo");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="writeUs-container">
      <h2 className="writeUs-title">Escríbenos tu opinión</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="writeUs-form">
        <div className="writeUs-formGroup">
          <label htmlFor="message" className="writeUs-label">
            Tu mensaje *
          </label>
          <textarea
            id="message"
            {...register("message", { required: "Tu mensaje es requerido" })}
            className={`writeUs-input ${
              errors.message ? "writeUs-errorInput" : ""
            }`}
            rows={5} // Adjust rows as needed
          />
          {errors.message && (
            <span className="writeUs-errorMessage">
              {errors.message.message}
            </span>
          )}
        </div>
        {error && <div className="writeUs-formError">{error}</div>}
        {successMessage && (
          <div className="writeUs-formSuccess">{successMessage}</div>
        )}{" "}
        {/* Success message display */}
        <div className="writeUs-formActions">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="writeUs-cancelButton"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={submitting}
            className="writeUs-submitButton"
          >
            {submitting ? "Enviando..." : "Enviar mensaje"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default WriteUs;
